export function buildFlatServiceItems(stores, serviceKey) {
  if (!Array.isArray(stores)) return [];

  // Optional: de-duplicate by store id if backend duplicates rows
  const seen = new Set();
  const deduped = [];
  for (const s of stores) {
    const id = String(s?.store ?? "");
    if (!id || seen.has(id)) continue;
    seen.add(id);
    deduped.push(s);
  }

  return deduped.map((s) => {
    const svc = s?.[serviceKey] || {};
    const status = svc.status ?? "unknown";
    const rawColor = (svc.color ?? "gray").toLowerCase();
    const color = rawColor === "amber" ? "#FFC107" : (svc.color ?? "gray");
    const issue = svc.issue ? String(svc.issue) : "";

    return {
      id: s.store,
      status,
      color,
      issue,
    };
  });
}

/** Map UI labels to API keys (adjust if your labels change). */
export function labelToServiceKey(label) {
  const t = String(label || "")
    .trim()
    .toLowerCase();
  //console.log("label", t)
  if (t === "digital ordering" || t === "digitalordering")
    return "DigitalOrdering";
  if (t === "sesame") return "Sesame";
  if (t === "eprod") return "eProd";
  if (t === "mystore") return "MyStore";
  return null;
}

export function getChicagoTimeDifferenceInMinutes(compareTimestamp) {
  const chicagoNow = new Date(
    new Date().toLocaleString("en-US", { timeZone: "America/Chicago" }),
  ).getTime();
  //console.log("Chicago now (ms):", chicagoNow, "Compare timestamp (ms):", compareTimestamp);
  const diffMs = chicagoNow - compareTimestamp;
  console.log("Difference (ms):", diffMs);
  const minutes = Math.round((Math.abs(diffMs) / 1000 / 60) * 100) / 100;

  return {
    minutes,
    //relation: diffMs > 0 ? "Past" : "Future",
  };
}

import { navigation, nerdlet } from "nr1";

export const openEntityWithOneDayDuration_old = (
  entityGuid,
  storeId,
  serviceName,
  accountId,
) => {
  if (!entityGuid) return;
  if (serviceName === "MYSTORE") {
    return;
  }
  // console.log(
  //   "Opening entity with GUID:",
  //   entityGuid,
  //   "Store ID:",
  //   storeId,
  //   "Service Name:",
  //   serviceName,
  //   "Account ID:",
  //   accountId,
  // );
  //let accountId = 3592556;
  //console.log("Row clicked with function:", { entityGuid, storeId, serviceName });
  let guid = btoa(`${accountId}|EXT|${serviceName}|${storeId}`).replaceAll(
    "=",
    "",
  );

  //const safeGuid = String(entityGuid).trim();
  //const oneDay = 24 * 60 * 60 * 1000;
  //nerdlet.setConfig({ timePickerDefaultOffset: oneDay });

  // Scope the entity view to this store. The platform binds it to the
  // dashboard's `entity` NRQL variable; the standalone panel does the same.
  navigation.openStackedEntity(guid, {
    selectedVariables: { entity: storeId },
    // Which service the alert belongs to. Every alert guid the health API
    // emits is stamped DIGITALORDERING whatever the service actually is — a
    // Sesame alert on store 00055 carries EXT|DIGITALORDERING|00055 — so the
    // guid cannot name it, and resolving the dashboard from the guid's type
    // lands on the wrong one. The caller already knows; pass it on.
    serviceName: serviceName || null,
  });
};
import { SKIP_NAVIGATION_ALERTS } from "./constants/healthEndpoints";
export const openEntityWithOneDayDuration = (
  entityGuid,
  storeId,
  serviceName,
  accountId,
  alert,
) => {
  if (!entityGuid) return;
  if (serviceName === "MYSTORE") {
    return;
  }

  if (SKIP_NAVIGATION_ALERTS.includes(alert)) {
    return;
  }

  let guid = entityGuid;
  if (entityGuid === "NOGUID") {
    guid = btoa(`${accountId}|EXT|${serviceName}|${storeId}`).replaceAll(
      "=",
      "",
    );
  }

  // Scope the entity view to this store. The platform binds it to the
  // dashboard's `entity` NRQL variable; the standalone panel does the same.
  navigation.openStackedEntity(guid, {
    selectedVariables: { entity: storeId },
    // Which service the alert belongs to. Every alert guid the health API
    // emits is stamped DIGITALORDERING whatever the service actually is — a
    // Sesame alert on store 00055 carries EXT|DIGITALORDERING|00055 — so the
    // guid cannot name it, and resolving the dashboard from the guid's type
    // lands on the wrong one. The caller already knows; pass it on.
    serviceName: serviceName || null,
  });
};
/* =========================================================
   Build service-level issues from new services[] structure
   ========================================================= */
export function buildServiceIssues(stores = [], serviceName) {
  const result = {
    impactedCount: 0,
    groups: {},
  };

  if (!Array.isArray(stores)) return result;

  for (const store of stores) {
    const serviceIssues = store?.services?.[serviceName];

    if (!Array.isArray(serviceIssues) || serviceIssues.length === 0) continue;

    // Count store once per service if impacted
    result.impactedCount += 1;

    for (const issue of serviceIssues) {
      const alert = issue.alert || "Unknown Issue";

      if (!result.groups[alert]) {
        result.groups[alert] = [];
      }

      result.groups[alert].push({
        store: store.store,
        detail: issue.detail,
        guid: issue.guid,
        status: store.status,
        count: issue.count ?? 1,
      });
    }
  }

  // Sort stores numerically inside each alert
  for (const alert in result.groups) {
    result.groups[alert].sort((a, b) => Number(a.store) - Number(b.store));
  }

  return result;
}
export function formatGroupsForUI(groups = {}) {
  const formatted = {};

  if (!groups || typeof groups !== "object") {
    return formatted;
  }

  for (const alert of Object.keys(groups)) {
    const stores = groups[alert] || [];

    formatted[alert] = {
      alert,
      count: stores.length,
      stores,
    };
  }

  return formatted;
}

/* =========================================================
   Build display data for a single service
   ========================================================= */
export function buildServiceDisplayData(stores = [], serviceName, percent = 0) {
  const issues = buildServiceIssues(stores, serviceName);

  return {
    name: serviceName,
    percent,
    impactedCount: issues.impactedCount,
    digitalDetailGroups: formatGroupsForUI(issues.groups),
  };
}

/* =========================================================
   Build display data for ALL services
   ========================================================= */
export function buildAllServicesDisplayData(stores = [], serviceApiMap = {}) {
  const result = {};

  if (!serviceApiMap || typeof serviceApiMap !== "object") return result;

  for (const serviceName of Object.keys(serviceApiMap)) {
    result[serviceName] = buildServiceDisplayData(
      stores,
      serviceName,
      serviceApiMap[serviceName],
    );
  }

  return result;
}

export function buildAlertsFromAllServices(servicesDisplayData = {}) {
  const result = {};

  for (const serviceName of Object.keys(servicesDisplayData)) {
    const serviceData = servicesDisplayData[serviceName];
    const groups = serviceData?.digitalDetailGroups || {};

    for (const alert of Object.keys(groups)) {
      const group = groups[alert];

      if (!result[alert]) {
        result[alert] = {
          alert,
          count: 0,
          stores: [],
        };
      }

      result[alert].count += group.count;

      result[alert].stores.push(
        ...group.stores.map((s) => ({
          ...s,
          service: serviceName,
        })),
      );
    }
  }

  /*  SORT STORES ASCENDING (by store number/id) */
  for (const alert in result) {
    result[alert].stores.sort((a, b) => Number(a.store) - Number(b.store));
  }

  return result;
}
export function getRelativeTime(timestampMs) {
  const diffMs = timestampMs - Date.now();
  const diffSec = Math.round(diffMs / 1000);

  const rtf = new Intl.RelativeTimeFormat('en', { numeric: 'auto' });

  const absSec = Math.abs(diffSec);

  if (absSec < 60) return rtf.format(diffSec, 'second');
  if (absSec < 3600) return rtf.format(Math.round(diffSec / 60), 'minute');
  if (absSec < 86400) return rtf.format(Math.round(diffSec / 3600), 'hour');

  return rtf.format(Math.round(diffSec / 86400), 'day');
}